import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, throwError } from 'rxjs';

import { SIGNIN_PATH } from '../auth.models';
import { UnauthorizedHandlerService } from '../services/unauthorized-handler.service';

import type {
  HttpErrorResponse,
  HttpInterceptorFn,
} from '@angular/common/http';

/**
 * 401 はセッション切れとみなし UnauthorizedHandlerService に委譲する。
 * 403 等はそのまま伝播し、Toast 表示はページ側に委ねる。
 * signin パス滞在中は AmplifyAuthenticator が裏で発火する認証 API の 401 を握り潰し、
 * サインイン操作中のユーザーに「セッションが切れました」を被せないようにする。
 */
export const errorInterceptor: HttpInterceptorFn = (req, next) => {
  const router = inject(Router);
  const unauthorizedHandler = inject(UnauthorizedHandlerService);

  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      if (error.status === 401 && !router.url.startsWith(SIGNIN_PATH)) {
        unauthorizedHandler.handle();
      }
      return throwError(() => error);
    }),
  );
};
